<template>

<v-dialog v-model="dialog" width="600px">
  <v-card>
    <p class=".title ma-2">Add a City</p>
    <v-form ref="addPlts" v-model="addPltsValid">

     <v-row no-gutters>
      <v-col class="mx-2" cols="8">
           <v-text-field v-model="plts_naam" required label="City name" :rules="plts_naamRules"></v-text-field>
         </v-col>
     </v-row>

    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addPlts" :disabled="!addPltsValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

// import {bus} from "../../../main";

export default {
  data() { 
    return {
      dialog: false,
      addPltsValid: false,
      huis_encrid: null,
      plts: {},
      plts_naam: '',
      plts_naamRules: [
          v => !!v || "A description / name value is required"
      ]
    }
  },
  methods: {
    open(huis_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/plts/getHuisToAddPlts.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuisToAddPlts"
          },
          getHuisToAddPlts: {
            huis_encrid: huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.plts = res.data.getHuisToAddPlts;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addPlts() { 
      this.$axios
        .post("ares/json/ares/huis/plts/addPlts.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addPlts"
          },
          addPlts: {
            huis_encrid: this.plts.huis_encrid,
            plts_naam: this.plts_naam
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
            if (res.data.addPlts.color == "success")
               //setTimeout(() => { this.$router.reload('/huis/onHuis/' + res.data.addPlts.huis_encrid); }, 2000);                                      
               //bus.$emit("closeDialog", "reload");
                           
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addPlts.text,
              color: res.data.addPlts.color
            }); 
            this.$emit('updateData'); 
            this.dialog = false;
          }
        })
    }
  }
}
</script>

